<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col cols="12" :class="$vuetify.breakpoint.smAndDown ? 'px-1' : ''">
          <v-sheet elevation="0">
            <v-slide-group
              class="pa-4 items-group-class"
              active-class="#6c5dd4"
              show-arrows
            >
              <v-slide-item
                class="rounded-lg"
                v-for="category in UnitsCardCount"
                :key="category"
                v-slot="{ active, toggle }"
              >
                <v-card
                  :color="active ? '#6c5dd4' : '#f1f2f6'"
                  elevation="0"
                  class="ma-4"
                  height="100"
                  width="220"
                  @click="toggle"
                >
                  <v-row
                    class="fill-height px-3"
                    align="center"
                    justify="center"
                  >
                    <v-scale-transition>
                      <v-col class="d-flex pl-1">
                        <v-col cols="3" class="mt-2">
                          <span
                            class="px-2 py-3 rounded-xl mr-3"
                            :color="active ? 'white' : 'black'"
                            :style="{
                              'background-color': active ? 'white' : '#6c5dd4',
                            }"
                            widht="10px"
                          >
                            <v-icon
                              size="25"
                              :color="active ? 'black' : 'white'"
                              >mdi-{{ category.icon }}</v-icon
                            >
                          </span>
                        </v-col>
                        <v-col cols="10">
                          <span
                            :class="[
                              'text-h5',
                              active ? 'white--text' : 'black--text',
                            ]"
                            >{{ category.count }}</span
                          >
                          <br />
                          <span
                            :class="[
                              'text-caption',
                              active ? 'white--text' : 'black--text',
                            ]"
                            >Total {{ category.name }} counts
                          </span>
                        </v-col>
                      </v-col>
                    </v-scale-transition>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          md="12"
          :class="$vuetify.breakpoint.smAndDown ? 'px-1' : ''"
          class="pt-0"
        >
          <v-card elevation="0">
            <v-card-title class="pb-0">
              <v-col cols="12" class="px-0 pb-1 pt-0">
                <v-col cols="12" class="py-0">
                  <span class="text-h6">Total units count ({{ count }})</span>
                </v-col>
              </v-col>
              <vs-button
                class="mx-2 text-caption"
                color="#6c5dd4"
                to="units/create"
                >+ Add Unit</vs-button
              >
              <v-spacer></v-spacer>
              <vs-pagination
                v-model="page"
                color="#6c5dd4"
                :length="paginationLength"
              >
              </vs-pagination>
              <vs-input
                class="search-field-input text-caption"
                v-model="search_keyword"
                placeholder="Search ... "
                prepend-inner-icon="mdi-magnify"
                @keydown.enter="getData"
                @change="page = 1"
                clearable
              ></vs-input>
              <vs-button
                v-if="units.length != 0"
                :class="[
                  $vuetify.breakpoint.smAndDown ? 'ml-8' : 'mx-4',
                  'text-caption',
                ]"
                color="#6c5dd4"
                :loading="isExcelloading"
                :disabled="isExcelloading"
                @click="generateExcel()"
                >Generate Excel</vs-button
              >
              <vs-button 
              class="float-right  "
                v-if="units.length != 0"
                :class="[
                  $vuetify.breakpoint.smAndDown ? '' : 'mx-4',
                  'text-caption',
                ]"
                color="#6c5dd4"
                :loading="isExcelloading"
                :disabled="isExcelloading"
                @click="ReportDateDialog = true"
                >Send Mail Report</vs-button
              >
            </v-card-title>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="#6c5dd4"
            ></v-progress-linear>
            <v-simple-table fixed-header height="600">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Address</th>
                    <th class="text-left">Latitude</th>
                    <th class="text-left">Longitude</th>
                    <th class="text-left">IMEI No</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="units.length != 0">
                  <tr v-for="(unit, i) in units" :key="`unit${i}`">
                    <td style="min-width: 85px">
                      <v-tooltip bottom v-if="unit.is_active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>unit is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="unit.is_active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>unit is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td style="position: relative">
                      {{ unit.first_name || ""
                      }}<iframe
                        v-if="unit.is_active == true"
                        src="https://giphy.com/embed/2QlWRjEHV0qw0JuOj7"
                        width="30px"
                        height="20px"
                        style="position: absolute"
                        frameBorder="0"
                      ></iframe>
                    </td>
                    <td>{{ unit.residence_address || "" }}</td>
                    <td>{{ unit.latitude || "" }}</td>
                    <td>{{ unit.longitude || "" }}</td>
                    <td>{{ unit.imei_number || "" }}</td>
                    <td class="text-center">
                      <div
                        v-if="$vuetify.breakpoint.smAndDown"
                        class="text-center"
                      >
                        <v-menu stransition="slide-x-transition" bottom left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="white"
                              class="px-0"
                              min-width="21"
                              height="29"
                              elevation="1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item :to="`/units/${unit.id}`">
                              <v-list-item-title class="text-caption">
                                Edit Unit</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item :to="`/datas/${unit.id}`">
                              <v-list-item-title class="text-caption">
                                View Unit Data</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                      <v-row v-else justify="center">
                        <v-btn
                          class="mx-2"
                          fab
                          x-small
                          elevation="0"
                          color="#6c5dd4"
                          :to="`units/${unit.id}`"
                          dark
                        >
                          <v-icon dark> mdi-pencil </v-icon>
                        </v-btn>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :to="`/datas/${unit.id}`"
                              elevation="0"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-img
                                :src="require('../../assets/speedometer.gif')"
                                width="50"
                              />
                            </v-btn>
                          </template>
                          <span>View Unit Data</span>
                        </v-tooltip>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <vs-dialog  v-model="ReportDateDialog" :loading="isMailSending">
        <v-col sm="12">
          <v-menu
            v-model="report_date_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <label for="">Select Report Date</label>
              <vs-input
                v-model="report_date"
                placeholder="Select Report Date"
                v-bind="attrs"
                readonly
                v-on="on"
                clearable
                @click:clear="report_date = null"
              ></vs-input>
            </template>
            <v-date-picker
              v-model="report_date"
              @change="report_date_menu = false"
              :max="todayDate"
            ></v-date-picker>
          </v-menu>
          <span style="color: red" class="text-caption">
            {{ errors && errors.report_date ? errors.report_date : "" }}
          </span>
          <v-col cols="12" align="right">
            <v-col cols="4">
              <vs-button
                :color="is_mail_sent  ? 'success' :  '#6c5dd4'"
                block
                :disabled="isMailSending"
                @click="autoMail"
              >
                <span v-if="is_mail_sent != true"> Send </span>
                <span v-else> Sended </span>
                </vs-button
              >
            </v-col>
          </v-col>
        </v-col>
      </vs-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "unitsPage",
  data() {
    return {
      units: [],
      unitdata: {
        datas: [],
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      isLoading: false,
      isExcelloading: false,
      UnitEditDialog: false,
      ReportDateDialog: false,
      UnitsCardCount: [],
      UnitId: null,
      report_date_menu: false,
      report_date: "",
      isMailSending: false,
      is_mail_sent: false,
      todayDate: new Date().toISOString().substr(0, 10),
    };
  },
  watch: {
    page: "getData",
    Datapage: "getUnitDatas",
  },
  mounted() {
    if (this.roleName == "Super Admin") {
      this.companyId = this.$store.getters["settings/getCompanyId"];
    }
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let units = [];
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword;
      if (this.roleName == "Super Admin") {
        const config = {
          headers: {
            "Company-id": this.companyId,
          },
        };
        units = await axios.get(`units?${query}`, config);
      } else {
        units = await axios.get(`units?${query}`);
      }
      this.units = units.data.data;
      this.count = units.data.count;
      // Count active and inactive units
      let activeCount = this.units.filter((unit) => unit.is_active).length;
      let inactiveCount = this.units.filter((unit) => !unit.is_active).length;
      this.UnitsCardCount = [
        { name: "Units", count: this.count, icon: "unity" },
        { name: "Active units", count: activeCount, icon: "leaf" },
        { name: "In-Active units", count: inactiveCount, icon: "leaf-off" },
      ];
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    async generateExcel() {
      this.isExcelloading = true;
      let query = "search_keyword=" + this.search_keyword;
      let response = [];
      try {
        if (this.roleName == "Super Admin") {
          const config = {
            headers: {
              "Company-id": this.companyId,
            },
          };
          response = await axios.get(`unitsExport?${query}`, config);
        } else {
          response = await axios.get(`unitsExport?${query}`);
        }
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
      }
      this.isExcelloading = false;
    },
    async autoMail() {
      this.isMailSending = true;
      let query = "report_date=" + this.report_date;
      let response = [];
      try {
        if (this.roleName == "Super Admin") {
          const config = {
            headers: {
              "Company-id": this.companyId,
            },
          };
          response = await axios.get(`auto_mailer?${query}`, config);
        } else {
          response = await axios.get(`auto_mailer?${query}`);
        }
        this.is_mail_sent = response.data.is_mail_sent;
        this.isMailSending = false;
        this.ReportDateDialog = false;
        this.report_date = ""
      } catch (error) {
        console.error("Error fetching Excel data:", error);
        this.isMailSending = false;
        this.ReportDateDialog = false;
        this.report_date = ""
      }
    },
    async Delete_this(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.delete(`units/${id}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
